import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginImage from "./RtelLogin.jpg";
import styles from "./Login.module.css";

import {
  Row,
  Col,
  Alert,
  Container,
  Dropdown,
  DropdownToggle,
} from "reactstrap";

//Language selecter

import { withTranslation } from "react-i18next";

import Button from "src/components/Common/UI/Forms/Button";
import ApplicationMenu from "src/components/VerticalLayout/ApplicationMenu";
import LanguageHorizontalSelector from "src/components/CommonForBoth/TopbarDropdown/LanguageHorizontalSelector";

import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useLogin } from "./api/useLogin";
import { MisterIcon, MisterLogo } from "@rtel/mister-icons";
import { getLocalParameters } from "src/helpers/AppCode";
import Greece20Logo from "../../../assets/images/greece_2_0.png";


interface LoginProps {
  history: object;
  t?: any;
}

interface ILoginForm {
  username: string;
  password: string;
}

const Login = ({ t }: LoginProps) => {
  const [menu, setMenu] = useState<boolean>(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);
  const loginMutation = useLogin({data: {}});
  const navigate = useNavigate();

  const initialValues: ILoginForm = {
    username: "",
    password: "",
  };

  const ApplicationsList = [
    {
      appName: "Metrics",
      isActive: true,
    },
    {
      appName: "Call Routing",
      isActive: false,
    },
    {
      appName: "Wallboards",
      isActive: false,
    },
    {
      appName: "Campaing Manager",
      isActive: true,
    },
  ];

  const LoginSchema = Yup.object().shape({
    username: Yup.string().required(t("Username is Required!")),
    password: Yup.string().required(t("Password is Required!")),
  });

  return (
    <React.Fragment>
      <div className="auth-page">
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={5} md={5}>
              <div className="auth-full-page-content d-flex">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row>
                      <Col>
                        <Dropdown
                          isOpen={menu}
                          toggle={() => setMenu(!menu)}
                          className="d-inline-block w-100 text-center applications-dropdown"
                        >
                          <DropdownToggle
                            className={`btn header-item applications-toggle d-flex ${
                              menu == true ? "active" : ""
                            }`}
                            id="page-header-user-dropdown"
                            tag="button"
                          >
                            <MisterLogo name="MisterCampaingManagerLogo" isActive={true} />

                            <span className="application-title application-title-login">
                              MISTER
                              <br />
                              <span className="application-text application-text-login">
                                SYD{" "}
                                {menu == true ? (
                                  <MisterIcon name="ChevronUp" size="sm" />
                                ) : (
                                  <MisterIcon name="ChevronDown" size="sm" />
                                )}
                              </span>
                            </span>
                          </DropdownToggle>

                          
                        </Dropdown>
                      </Col>
                      <Col className="text-end pe-5 d-none">
                        <LanguageHorizontalSelector />
                      </Col>
                    </Row>

                    <div
                      className={`auth-content my-auto ${styles.loginContainer}`}
                    >
                      <h1 className="text-center">{t("Login")} </h1>
                      <Formik
                        initialValues={initialValues}
                        validationSchema={LoginSchema}
                        onSubmit={async (values: ILoginForm, { setSubmitting }) => {
                          await loginMutation.mutateAsync({data: {
                            loginTypeID: 1,
                            sysApplicationsID: process.env.REACT_APP_ID,
                            username: values.username,
                            password: values.password,
                          }}).then(async () => {
                            const parameters = await getLocalParameters();
                            localStorage.setItem(`${process.env.REACT_APP_BASENAME}_localParameters`, JSON.stringify(parameters));
                          });
                          navigate('/');
                          setSubmitting(false);
                        }}
                      >
                        {({ errors, touched, isSubmitting }) => (
                          <Form>
                            {loginMutation.isError && (
                              <Alert color="danger">{t(loginMutation.error.response?.data)}</Alert>
                            )}
                            
                            <div className="mb-3">
                              <div className="d-flex align-items-start">
                                <div className="flex-grow-1">
                                  <label className="form-label">
                                    {t("Username")}
                                  </label>
                                </div>
                              </div>
                              <div className="mb-3">
                                <Field
                                  name="username"
                                  label={t("Username")}
                                  className="form-control"
                                  placeholder=""
                                  type="text"
                                  required
                                />
                               <div className="text-danger"> {errors.username && touched.username ? (
                                  <div>{errors.username}</div>
                                ) : null}</div>
                              </div>
                            </div>
                            <div className="mb-3">
                              <div className="d-flex align-items-start">
                                <div className="flex-grow-1">
                                  <label className="form-label">
                                    {t("Password")}
                                  </label>
                                </div>
                              </div>

                              <div className="input-group ">
                                <Field
                                  name="password"
                                  type={isPasswordVisible ? "text" : "password"}
                                  className={`form-control ${styles.passfield}`}
                                  required
                                  placeholder=""
                                />
                               
                                <span
                                  className={`input-group-text ${styles.hidebutton}`}
                                  onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                                >
                                  {isPasswordVisible ? (
                                    <MisterIcon name="Eye" size="sm" />
                                  ) : (
                                    <MisterIcon name="EyeOff" size="sm" />
                                  )}
                                </span>
                              </div>
                              <div className="text-danger">{errors.password && touched.password ? (
                                  <div>{errors.password}</div>
                                ) : null}</div>
                            </div>

                            <div className="mb-3">
                            <Button
                                type="submit"
                                size="xl"
                                styletype="primary"
                                disabled={isSubmitting}
                              >
                                {t("Log In")}
                              </Button>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                    <Row className="text-start text-secondary">
                      <Col>
                        <div className="d-flex h-100 align-items-end justify-content-start pb-3 ps-5">
                          <a
                            href="https://rtelworld.com/mister-ca-cloud"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={Greece20Logo} alt="Greece 2.0 - National Recovery and Resilience Plan - Funded by the European Union" className={styles.greeceLogo} />
                          </a>
                        </div>
                      </Col>
                      <Col>
                        <p className={`text-end pe-5 ${styles.p}`}>
                          <a
                            href="https://rtelworld.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-muted"
                          >
                            ©RTEL SA {new Date().getFullYear()}
                          </a>
                        </p>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
            <Col xxl={7} md={7}>
              <div
                className={styles.loginBanner}
                style={{ backgroundImage: `url(${LoginImage})` }}
              ></div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Login);
